import { createContext } from "react";

const ChannelThemeContext = createContext(undefined as any);

export default ChannelThemeContext;
